var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-cascader',{attrs:{"options":_vm.datas,"props":_vm.props,"clearable":"","show-all-levels":_vm.isShowAllLevels},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }